import { LayoutComponent } from "@jelly/lesson";

const components: LayoutComponent[] = [
  null,
  null,
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">A</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">B</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">C</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">D</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">E</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: `<span style="font-weight: 700; font-size:14px">F</span></br>Rw (dB)`,
          scrollbars: false,
          formatter: "html",
          styles: {
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
          },
        },
      },
    },
  },
];

export default components;
